import { AICoachGoalType } from 'enums/AICoach';

export const getShiftBadgeText = (
  goalType: AICoachGoalType,
  goalAcceleration: string | undefined,
  description?: string,
): string | undefined => {
  switch (goalType) {
    case AICoachGoalType.PayDownCreditCardDebt:
    case AICoachGoalType.PayDownStudentLoanDebt:
    case AICoachGoalType.ImproveCreditScore:
      return goalAcceleration ? `Pay debt ${goalAcceleration} faster` : undefined;
    case AICoachGoalType.BuildEmergencyFund:
      return goalAcceleration ? `Save for emergencies ${goalAcceleration} faster` : undefined;
    case AICoachGoalType.SaveForSpecificExpense:
      return goalAcceleration ? `Save for ${description ?? 'your expense'} ${goalAcceleration} faster` : undefined;
    case AICoachGoalType.SaveForRetirement:
      return goalAcceleration ? `Save for retirement ${goalAcceleration} faster` : undefined;
    case AICoachGoalType.Other:
      return goalAcceleration ? `Save for ${description ?? 'your goal'} ${goalAcceleration} faster` : undefined;
    default:
      return goalAcceleration ? `Save for debt ${goalAcceleration} faster` : undefined;
  }
};
